import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'

import { ProviderService } from '../services/providers/provider.service';
import { PlanService } from '../services/plans/plan.service';

import { Provider } from '../classes/provider';
import { Plan } from '../classes/plan';
import { ExtraParameter } from '../classes/extraParameter';
import { Auth } from '../services/auth.service';


@Component({
  selector: 'providers',
  templateUrl: './providers.component.html',
  styleUrls: ['./providers.component.css']
})
export class ProvidersComponent implements OnInit {

  providers: Provider[];
  plans: Plan[];
  languages:string[]
  parameters: ExtraParameter[]
  showAllProviders:Boolean=false;

  /*example
  {
    file: PSServiceProvider
    name: Service for PS
  }*/
  services:any[]=[]
  newProvider: Provider = new Provider();
  selectedServiceIndex:any
  selectedLang:any
  selectedParameterIndex:any
  hasWriteProviderPermission:boolean = false;

  constructor(protected providerService: ProviderService,
    protected planService: PlanService,
    protected router: Router,
    protected auth: Auth) {
  }

  protected getDetailUrl(): string {
    return '/providers/'
  };

  ngOnInit() {
    this.loadAppsInfo();
    this.newProvider.auth0ConnectionName = "ps-"
    this.hasWriteProviderPermission = this.auth.hasWriteProviderPermission();
  }

  loadAppsInfo() {
    let promisesOne = []
    promisesOne.push(this.providerService.getServices())
    promisesOne.push(this.providerService.getAll())
    promisesOne.push(this.providerService.getLanguages())
    promisesOne.push(this.providerService.getParameters())
    Promise.all(promisesOne)
    .then(response => {
      this.services = response[0]
      this.languages = response[2]
      this.parameters = response[3]
      response[1].sort(function(provider1, provider2) {
        return provider1.name.localeCompare(provider2.name);
      });
      this.providers = response[1]
      let parameter = new ExtraParameter()
      parameter["name"]="No Parameter"
      parameter["id"]="0"
      this.parameters.unshift(parameter)
  })
}

  add() {
    if (!this.newProvider.auth0ConnectionName ||
    !this.newProvider.billingEmailAddress  ||
    !this.newProvider.modelObjectName||
    !this.newProvider.name ||
    this.newProvider.minAge==undefined ||
    !this.newProvider.serviceObjectName ||
    !this.newProvider.language) {
      alert("There are missing fields")
      return
    }
    if (this.newProvider.extraParameter=="0"){
      delete this.newProvider.extraParameter
    }

    this.newProvider.auth0ConnectionName+=this.newProvider.name
    console.log(this.newProvider)
    this.providerService.create(this.newProvider)
      .then(_ => {
        this.loadAppsInfo();
        this.newProvider.name = "";
        this.newProvider.serviceObjectName = "";
        this.newProvider.auth0ConnectionName = "ps-";
      })
      .catch(error => {
        alert("There was an error creating the provider. Server message: " + error.message);
      });
  }

  onNotify(message: string) {
    if (message == 'deleted')
      this.loadAppsInfo();
  }

  viewDetail(provider) {
    window.open(window.location.origin+this.getDetailUrl()+provider.id);
  }

  serviceChanged(event){
    this.newProvider.modelObjectName = this.services[this.selectedServiceIndex].affiliate
    this.newProvider.serviceObjectName = this.services[this.selectedServiceIndex].file
  }

  serviceParameterChanged(event){
    console.log(this.selectedParameterIndex)
    this.newProvider.extraParameter = this.parameters[this.selectedParameterIndex].id
  }

  changeProvidersShow(showAll){
    this.showAllProviders = showAll;
  }
}



// WEBPACK FOOTER //
// ./src/app/providers/providers.component.ts